import { PlaybackEventEmitter, PlaybackEvent } from '@annunciate/core';
import { getStreamFromContent } from '@annunciate/download';
export const onPlayNewVideo = async (client, content) => {
    const streamable = await getStreamFromContent(content, client);
    if (!streamable.content || !streamable.stream) {
        PlaybackEventEmitter.emit(PlaybackEvent.RESTART);
        return content;
    }
    streamable.content.asset.src = streamable.stream;
    return streamable.content;
};
//# sourceMappingURL=onPlayNewVideo.js.map